<template>
  <!-- Forbidden Area Map Modal -->
  <div v-if="gameState.inForbiddenMap" class="forbidden-modal" @click="closeModal">
    <div class="forbidden-card" @click.stop>
      <!-- Fixed Header -->
      <div class="forbidden-header">
        <h3>禁地地图</h3>
        <p>探索禁地，寻找机缘与宝藏。</p>
      </div>

      <!-- Scrollable Content -->
      <div class="forbidden-content">
        <div class="exploration-info">
          探索度：{{ currentExplorationCompletion }}% ({{ exploredCellCount }}/{{
            gameState.mapSize * gameState.mapSize }})
        </div>
        <div class="map-grid" :style="{ gridTemplateColumns: `repeat(${gameState.mapSize}, 1fr)` }">
          <div
            v-for="(cell, index) in mapDisplay"
            :key="index"
            :class="['map-cell', getCellClass(cell)]"
          >
            {{ getCellSymbol(cell) }}
          </div>
        </div>
        <div class="map-legend">
          <div class="legend-item"><span class="legend-symbol">@</span> 玩家位置</div>
          <div class="legend-item"><span class="legend-symbol">·</span> 未探索</div>
          <div class="legend-item"><span class="legend-symbol">□</span> 安全区域</div>
          <div class="legend-item"><span class="legend-symbol">▲</span> 危险区域</div>
          <div class="legend-item"><span class="legend-symbol">☆</span> 机缘区域</div>
          <div class="legend-item"><span class="legend-symbol">★</span> 宝藏位置</div>
        </div>
        <!-- Forbidden area quick action buttons -->
        <div class="forbidden-buttons">
          <button @click="sendDirectCommand('up')" title="向上移动">↑</button>
          <button @click="sendDirectCommand('down')" title="向下移动">↓</button>
          <button @click="sendDirectCommand('left')" title="向左移动">←</button>
          <button @click="sendDirectCommand('right')" title="向右移动">→</button>
          <button @click="sendDirectCommand('scan')" title="神识扫描">扫描</button>
          <button @click="sendDirectCommand('exit')" title="退出禁地">退出</button>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div class="forbidden-footer">
        <button @click="closeModal" class="close-btn">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import gameController from '../game-controller/GameController.js';

export default {
  name: 'ForbiddenMap',
  props: {
    gameState: {
      type: Object,
      required: true
    },
    scannedCells: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentExplorationCompletion() {
      if (!this.gameState.inForbiddenMap || !this.gameState.exploredCells) return 0;
      const exploredCount = this.gameState.exploredCells.length;
      const totalCells = this.gameState.mapSize * this.gameState.mapSize;
      return Math.round((exploredCount / totalCells) * 100);
    },

    exploredCellCount() {
      return this.gameState.exploredCells ? this.gameState.exploredCells.length : 0;
    },

    mapDisplay() {
      if (!this.gameState.inForbiddenMap || !this.gameState.mapGrid) return [];

      const display = [];
      for (let y = 0; y < this.gameState.mapSize; y++) {
        for (let x = 0; x < this.gameState.mapSize; x++) {
          display.push({
            type: this.gameState.mapGrid[y][x],
            scanned: this.scannedCells.includes(`${x},${y}`),
            isPlayer: x === this.gameState.playerPos.x && y === this.gameState.playerPos.y
          });
        }
      }
      return display;
    }
  },
  methods: {
    // Map display methods
    getCellClass(cell) {
      let classes = ['map-cell'];
      if (cell.isPlayer) {
        classes.push('player');
      } else if (cell.scanned) {
        if (cell.type === 'safe' || cell.type === 'treasure') {
          classes.push('safe');
        } else if (cell.type === 'danger') {
          classes.push('danger');
        } else if (cell.type === 'opportunity') {
          classes.push('opportunity');
        }
      } else {
        classes.push('unexplored');
      }
      return classes.join(' ');
    },

    getCellSymbol(cell) {
      if (cell.isPlayer) {
        return '@';
      } else if (cell.scanned) {
        if (cell.type === 'safe') {
          return '□';
        } else if (cell.type === 'danger') {
          return '▲';
        } else if (cell.type === 'opportunity') {
          return '☆';
        } else if (cell.type === 'treasure') {
          return '★';
        }
      }
      return '·';
    },

    // Execute a direct command for forbidden area buttons
    sendDirectCommand(cmd) {
      this.$emit('command', cmd);
    },

    closeModal() {
      this.sendDirectCommand('exit');
    }
  }
};
</script>

<style scoped>
.forbidden-modal {
  position: absolute;
  inset: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 6, 23, 0.8);
  z-index: 250;
  backdrop-filter: blur(2px);
}

.forbidden-card {
  background: #071328;
  border-radius: 12px;
  border: 1px solid #334155;
  color: #e6eef8;
  min-width: 500px;
  max-width: 700px;
  height: 700px;
  display: flex;
  flex-direction: column;
}

.forbidden-header {
  flex-shrink: 0;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #334155;
}

.forbidden-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
}

.forbidden-footer {
  flex-shrink: 0;
  padding: 16px 20px 20px 20px;
  border-top: 1px solid #334155;
  display: flex;
  justify-content: center;
}

.forbidden-card h3 {
  margin: 0;
  font-size: 18px;
  color: #60a5fa;
  text-align: center;
  border-bottom: 1px solid #334155;
  padding-bottom: 8px;
}

.forbidden-card p {
  margin: 0;
  color: #cbd5e1;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
}

.exploration-info {
  font-size: 12px;
  color: #ffd166;
  font-weight: bold;
  margin-bottom: 12px;
  text-align: center;
}

.map-grid {
  display: grid;
  gap: 1px;
  background: #22303f;
  border: 1px solid #334155;
  margin-bottom: 16px;
  max-height: 400px;
  overflow: auto;
}

.map-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  min-width: 20px;
  min-height: 20px;
  background: #1e293b;
  color: #64748b;
  border: 1px solid #334155;
}

.map-cell.player {
  background: #0ea5a2;
  color: #042f2e;
}

.map-cell.unexplored {
  background: #1e293b;
  color: #64748b;
}

.map-cell.safe {
  background: #16a34a;
  color: #dcfce7;
}

.map-cell.danger {
  background: #dc2626;
  color: #fef2f2;
}

.map-cell.opportunity {
  background: #ca8a04;
  color: #fef3c7;
}

.map-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 11px;
  color: #cbd5e1;
  margin-bottom: 16px;
  justify-content: center;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.legend-symbol {
  font-weight: bold;
  min-width: 12px;
  text-align: center;
}

/* Forbidden area quick action buttons */
.forbidden-buttons {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.forbidden-buttons button {
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid #475569;
  background: #334155;
  color: #cbd5e1;
  cursor: pointer;
  font-size: 14px;
  min-width: 36px;
  transition: all 0.2s;
}

.forbidden-buttons button:hover {
  background: #475569;
  border-color: #60a5fa;
  transform: translateY(-1px);
}

.forbidden-buttons button:active {
  transform: translateY(1px);
}

.close-btn {
  padding: 8px 16px;
  border: 1px solid #dc2626;
  background: transparent;
  color: #dc2626;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
}

.close-btn:hover {
  background: #dc2626;
  color: white;
}

/* 适配移动设备 */
@media (max-width: 900px) {
  .forbidden-card {
    min-width: 90vw;
    max-width: 90vw;
  }

  .forbidden-header {
    padding: 16px 16px 12px 16px;
  }

  .forbidden-content {
    padding: 12px 16px;
  }

  .forbidden-footer {
    padding: 12px 16px 16px 16px;
  }

  .map-grid {
    max-height: 300px;
  }

  .map-cell {
    min-width: 16px;
    min-height: 16px;
    font-size: 10px;
  }
}
</style>
